import { styled } from '@mui/material';

import { SimulationActions } from './components/SimulationActions';
import { SimulationStatus } from './components/SimulationStatus';
import { SimulationMetrics } from './components/SimulationMetrics';

const StyledWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  svg: {
    fill: '#fff',
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  justifyContent: 'space-between',
}));

const StyledContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

export const SimulationDetails = () => {
  return (
    <StyledWrapper>
      <StyledContent>
        <SimulationStatus />
      </StyledContent>
      <SimulationMetrics />

      <SimulationActions />
    </StyledWrapper>
  );
};
